<section class="atw-page add-review-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>

  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>{{ 'addReview.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'addReview.title' | transloco }}</h2>
        <p>{{ 'addReview.subtitle' | transloco }}</p>
      </div>
    </div>

    <div *ngIf="isCheckingReview" class="apply-card add-review-card review-checking">
      <div class="review-loader"></div>
      <p>{{ 'addReview.checkingReview' | transloco }}</p>
    </div>

    <div *ngIf="!isCheckingReview && myReview" class="apply-card add-review-card my-review-card">
      <div class="review-form-head">
        <div>
          <span class="hero-badge">
            <b>{{ 'addReview.myReviewBadgeNumber' | transloco }}</b>
            {{ 'addReview.myReviewBadgeTitle' | transloco }}
          </span>

          <h3>{{ 'addReview.myReviewTitle' | transloco }}</h3>
          <p>{{ 'addReview.myReviewSubtitle' | transloco }}</p>
        </div>

        <div class="review-status-pill" [class]="myReview.status || 'pending'">
          {{ getStatusKey(myReview.status) | transloco }}
        </div>
      </div>

      <article class="submitted-review">
        <div class="submitted-review-top">
          <div class="submitted-avatar">
            {{ myReview.avatar || myReview.avatar_text || (myReview.name || myReview.name_en || '?').charAt(0) }}
          </div>

          <div>
            <h4>{{ myReview.name || myReview.name_en || '-' }}</h4>

            <p *ngIf="myReview.job_title || myReview.job_title_en">
              {{ myReview.job_title || myReview.job_title_en }}
            </p>

            <p *ngIf="myReview.company_name || myReview.company_name_en">
              {{ myReview.company_name || myReview.company_name_en }}
            </p>
          </div>
        </div>

        <div class="submitted-stars">
          <span
            *ngFor="let star of stars"
            [class.empty]="star > (myReview.stars || 0)"
          >
            ★
          </span>
        </div>

        <p class="submitted-text">
          “{{ myReview.text || myReview.text_en || '-' }}”
        </p>

        <div class="pending-note" *ngIf="myReview.status === 'pending' || !myReview.status">
          {{ 'addReview.pendingNote' | transloco }}
        </div>
      </article>
    </div>

    <form
      class="apply-card add-review-card"
      [formGroup]="reviewForm"
      (ngSubmit)="submitReview()"
      *ngIf="!isCheckingReview && !myReview && reviewForm"
    >
      <div class="review-form-head">
        <div>
          <span class="hero-badge">
            <b>{{ 'addReview.badgeNumber' | transloco }}</b>
            {{ 'addReview.badgeTitle' | transloco }}
          </span>

          <h3>{{ 'addReview.formTitle' | transloco }}</h3>
          <p>{{ 'addReview.formSubtitle' | transloco }}</p>
        </div>
      </div>

      <div class="form-grid">
        <label>
          <span>{{ 'addReview.name' | transloco }}</span>

          <input
            type="text"
            formControlName="name"
            [placeholder]="'addReview.namePlaceholder' | transloco"
          />

          <small class="field-error" *ngIf="isFieldInvalid('name')">
            {{ 'addReview.validation.nameRequired' | transloco }}
          </small>
        </label>

        <label>
          <span>{{ 'addReview.jobTitle' | transloco }}</span>

          <input
            type="text"
            formControlName="job_title"
            [placeholder]="'addReview.jobTitlePlaceholder' | transloco"
          />
        </label>

        <label>
          <span>{{ 'addReview.companyName' | transloco }}</span>

          <input
            type="text"
            formControlName="company_name"
            [placeholder]="'addReview.companyNamePlaceholder' | transloco"
          />
        </label>

        <label>
          <span>{{ 'addReview.rating' | transloco }}</span>

          <div class="stars-picker">
            <button
              type="button"
              *ngFor="let star of stars"
              [class.active]="star <= reviewForm.value.stars"
              (click)="setStars(star)"
            >
              ★
            </button>
          </div>
        </label>

        <label class="full">
          <span>{{ 'addReview.reviewText' | transloco }}</span>

          <textarea
            formControlName="text"
            rows="6"
            [placeholder]="'addReview.reviewTextPlaceholder' | transloco"
          ></textarea>

          <small class="field-error" *ngIf="isFieldInvalid('text')">
            {{ 'addReview.validation.textRequired' | transloco }}
          </small>
        </label>
      </div>

      <button class="submit-btn" type="submit" [disabled]="isSubmitting">
        <ng-container *ngIf="!isSubmitting; else submittingTpl">
          {{ 'addReview.submit' | transloco }}
        </ng-container>

        <ng-template #submittingTpl>
          {{ 'addReview.submitting' | transloco }}
        </ng-template>
      </button>
    </form>
  </div>
</section>